//src/app/features/questionnaires/components/QuestionnaireFooter/index.tsx
import useQuestionnaireStepState from 'app/hooks/useQuestionnaireStepState';
import { CancelIcon, NextIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import { useNavigate } from 'react-router-dom';

export interface IQuestionnaireFooterProps {
  onSubmit?: () => void;
  formId?: string;
}

export default function QuestionnaireFooter({
  formId,
  onSubmit,
}: IQuestionnaireFooterProps) {
  const navigate = useNavigate();
  const { nextTitle } = useQuestionnaireStepState();

  return (
    <div className="flex justify-end border-t gap-4 border-gray-800 p-4 tex-xs">
      <CustomButton
        onClick={() => navigate('/dashboard/questionnaires')}
        type="button"
        textColor="black"
        bgColor="white"
        textSize="text-xs"
        borderColor="gray-100"
        text="Cancel"
        height="h-10"
        width="max-w-min"
        prefix={<CancelIcon />}
      />

      {nextTitle && (
        <CustomButton
          suffix={<NextIcon />}
          textSize="text-xs"
          height="h-10"
          text={nextTitle}
          width="min-w-max whitespace-nowrap"
          form={formId}
          type="submit"
        />
      )}
    </div>
  );
}
